export default {
  add_items: 'Adicionar itens',
  remove_items: 'Remover itens',
  place_order: 'Fazer pedido',
  pay_now: 'Pagar agora · {{amount}}',
  go_to_menu: 'Ir para o menu',
  secure_checkout: 'Checkout seguro...',

  modals: {
    account_switch: {
      title: 'Já existe uma conta com o número {{phoneNumber}}',
      description: 'Iniciámos sessão na conta existente, mantendo as informações que introduziu 😊',
      button: 'Continuar',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Pagamento falhado',
      description: 'Verifique as suas informações de pagamento e tente novamente.',
    },
    internal_error: {
      title: 'Pedido sem sucesso 😔',
      description:
        'Infelizmente, ocorreu um problema inesperado com o seu pedido. A nossa equipa técnica já está a trabalhar nisso 🛠️.',
    },
    order_blocked: {
      title: 'Pedido bloqueado',
      description:
        'Detetámos atividade suspeita na sua conta e bloqueámos novos pedidos até {{datetime}}. Contacte o suporte em {{supportEmail}} para mais detalhes.',
      description_no_datetime:
        'Detetámos atividade suspeita na sua conta e bloqueámos novos pedidos. Contacte o suporte em {{supportEmail}} para mais detalhes.',
    },
  },

  toasts: {
    input_errors_found: 'Há alguns problemas com as informações do seu pedido',
    select_payment_method: 'Escolha um método de pagamento para fazer o seu pedido.',
  },
};
